import React from 'react';


const PaymentResponse = ({ status }) => {
  let message = 'success';
  let color = '';

  switch (status) {
    case 'success':
      message = '✅ Payment Successful';
      color = 'green';
      break;
    case 'pending':
      message = '⏳ Payment Pending';
      color = 'orange';
      break;
    case 'cancel':
      message = '❌ Payment Cancelled';
      color = 'red';
      break;
    default:
      message = '⚠️ Unknown Payment Status';
      color = 'gray';
  }

  return (
    <div className="payment-container">
      <div className="payment-box" style={{ borderColor: color }}>
        <h1 style={{ color }}>{message}</h1>
      </div>
    </div>
  );
};

export default PaymentResponse;
